import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard, CmsConfig, ConfigModule } from '@spartacus/core';
import { KnBrFindMyContactSearchResultComponent } from './kn-br-find-my-contact-search-result.component';
import { KnBrCustomerContextGuard } from 'src/app/shared/guards/kn-br-customer-context.guard';
import { SpinnerModule } from '@spartacus/storefront';
@NgModule({
    imports: [
        CommonModule,
        SpinnerModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CarlisleFindMyContactBodyComponent: {
                    component: KnBrFindMyContactSearchResultComponent,
                    guards: [AuthGuard, KnBrCustomerContextGuard],
                },
            },
        } as CmsConfig),
        KnBrFindMyContactSearchResultComponent,
    ]
})
export class KnBrFindMyContactSearchResultModule { }
